import { IChannelsVenue } from 'src/api/fetchChannels/types';
import { IAggregator, IVenue } from 'src/types/menu.types';
import { IPublishVenue } from '../../../components/PublishModal/types';
export const getVenuesToPublishTo = (
  venues: IChannelsVenue[],
  externalSystem: IAggregator,
  isTrial: boolean,
): IPublishVenue[] =>
  venues
    .filter((venue: IChannelsVenue) => isTrial === venue.is_trial)
    .map((venue: IChannelsVenue) => {
      const venueStatus = externalSystem?.venues?.find((v: IVenue) => venue.venue_id === v.venueId);
      return {
        name: venue.name,
        venue_id: venue.venue_id,
        is_trial: venue.is_trial,
        ...(venueStatus && {
          priceSchemeName: venueStatus.priceSchemeName,
          publicationDate: venueStatus.publicationDate,
          publicationStatus: venueStatus.publicationStatus,
        }),
      };
    });
